// src/components/layout/Navbar.js
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

// 1. List of Colleges
const collegesList = [
  { name: "UPES", slug: "upes-college" },
  { name: "Graphic Era", slug: "graphic-era" },
  { name: "SGRR", slug: "sgrr-university" },
  { name: "Uttaranchal University", slug: "uttaranchal-university" },
  { name: "HIT", slug: "himalayan-institute-technology" },
  { name: "DBIT", slug: "dev-bhoomi-uttarakhand-university" },
  { name: "GRD", slug: "grd-institute" },
  { name: "DD College", slug: "dd-college" },
  { name: "Sai Group of Institutions", slug: "sai-group" },
  { name: "ITM", slug: "itm-dehradun" },
  { name: "Doon Group of Colleges", slug: "doon-group" },
  { name: "Maya Group of Colleges", slug: "maya-group" },
  { name: "Tula’s Institute", slug: "tulas-institute" },
  { name: "Shivalik College", slug: "shivalik-college" },
  { name: "Jigyasa University", slug: "jigyasa-university" },
  { name: "JBIT", slug: "jbit-dehradun" },
  { name: "Doon Global University", slug: "doon-global-university" },
  { name: "CIMS", slug: "cims-dehradun" },
  { name: "SBS University", slug: "sbs-university" },
  { name: "DIT University", slug: "dit-university" },
  { name: "IMS Unison University", slug: "ims-unison-university" },
  { name: "Alpine Group", slug: "alpine-group" },
  { name: "Ras Bihari Bose Subharti", slug: "ras-bihari-bose" },
];

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isCollegesDropdownOpen, setIsCollegesDropdownOpen] = useState(false);

  useEffect(() => {
    const header = document.getElementById("header");
    function onScroll() {
      if (window.scrollY > 50) header?.classList.add("scrolled");
      else header?.classList.remove("scrolled");
    }
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleApplyNowClick = () => {
    navigate('/apply-now');
    setIsMobileMenuOpen(false); 
  };

  const openMobileMenu = () => {
    setIsMobileMenuOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setIsCollegesDropdownOpen(false);
    document.body.style.overflow = "auto";
  };

  const isHomePage = location.pathname === '/';
  const isAboutPage = location.pathname === '/about';
  const isContactPage = location.pathname === '/contact';

  return (
    <>
      <header id="header" className="site-header">
        <div className="header-container">
          
          {/* 1. LOGO */}
          <div className="logo-group">
            <img
              src="/CANEWLOGO.png"
              alt="College Aggregator Logo"
              className="nav-logo"
              onClick={() => navigate("/")}
              style={{ cursor: "pointer" }}
            />
          </div>

          {/* 2. NEW: MOBILE CENTER SOCIAL ICONS (Visible on Mobile Only) */}
        {/* 2. NEW: MOBILE CENTER (Phone + Socials) */}
          <div className="mobile-navbar-center">
             <a href="tel:+918126535439" className="mobile-center-phone">
               +91 81265 35439
             </a>
             <div className="mobile-navbar-socials">
               <a href="https://www.facebook.com/collegeaggregator?mibextid=ZbWKwL" target="_blank" rel="noreferrer">
                 <img src="/fb.png" alt="Facebook" />
               </a>
               <a href="https://instagram.com/collegeaggregator?igshid=ZDdkNTZiNTM=" target="_blank" rel="noreferrer">
                 <img src="/insta.png" alt="Instagram" />
               </a>
               <a href="https://www.linkedin.com/company/collegeaggregator/" target="_blank" rel="noreferrer">
                 <img src="/linkedin.png" alt="LinkedIn" />
               </a>
             </div>
          </div>
          {/* 3. RIGHT SIDE (Desktop Links + Mobile Hamburger) */}
          <div className="nav-right">
            {/* Desktop Links (Hidden on Mobile) */}
            <Link to="/" className={`nav-home-btn ${isHomePage ? 'active' : ''}`}>Home</Link>
            <Link to="/about" className={`nav-about-btn ${isAboutPage ? 'active' : ''}`}>About Us</Link>
            <Link to="/contact" className={`nav-contact-btn ${isContactPage ? 'active' : ''}`}>Contact Us</Link>
            
            <button type="button" onClick={handleApplyNowClick} className="nav-apply-btn">
              Apply Now
            </button>

            <div className="nav-social-desktop">
              <a href="https://www.facebook.com/collegeaggregator?mibextid=ZbWKwL" target="_blank" rel="noreferrer">
                <img src="/fb.png" alt="Facebook" />
              </a>
              <a href="https://instagram.com/collegeaggregator?igshid=ZDdkNTZiNTM=" target="_blank" rel="noreferrer">
                <img src="/insta.png" alt="Instagram" />
              </a>
              <a href="https://www.linkedin.com/company/collegeaggregator/" target="_blank" rel="noreferrer">
                <img src="/linkedin.png" alt="LinkedIn" />
              </a>
            </div>

            {/* Hamburger (Visible on Mobile) */}
           {/* Hamburger (Visible on Mobile) */}
            <button 
              className={`hamburger-btn ${isMobileMenuOpen ? 'active' : ''}`} 
              onClick={isMobileMenuOpen ? closeMobileMenu : openMobileMenu} 
              aria-label="Toggle Menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </header>

      {/* MOBILE MENU OVERLAY (Existing Code) */}
      <div 
        className={`mobile-menu-overlay ${isMobileMenuOpen ? 'active' : ''}`}
        onClick={(e) => {
          if (e.target.classList.contains('mobile-menu-overlay')) closeMobileMenu();
        }}
      >
        <div className="mobile-menu-panel">
          
            
            <button className="mobile-menu-close" onClick={closeMobileMenu}>&times;</button>
          

          <div className="mobile-menu-body">
            <nav className="mobile-nav">
              <div className="mobile-nav-row header-row">
                 <Link to="/" className="mobile-nav-link-text" onClick={closeMobileMenu}>Home</Link>
              </div>

            <div className="mobile-nav-row header-row">
                <span className="mobile-nav-link-text">
                  Colleges Near Me
                </span>
                <button 
                  className={`circle-arrow-btn ${isCollegesDropdownOpen ? 'open' : ''}`}
                  onClick={(e) => {
                    e.stopPropagation(); // Prevents menu from closing
                    setIsCollegesDropdownOpen(!isCollegesDropdownOpen);
                  }}
                  style={{ cursor: 'pointer', zIndex: 10 }} // Force clickable
                >
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    width="20"  /* Increased Size */
                    height="12" /* Increased Size */
                    viewBox="0 0 16 7"
                    style={{ pointerEvents: 'none', display: 'block' }} /* FIX: Lets click pass through */
                  >
                    <path 
                      fill="#000000" 
                      d="M8 6.5a.47.47 0 0 1-.35-.15l-4.5-4.5c-.2-.2-.2-.51 0-.71c.2-.2.51-.2.71 0l4.15 4.15l4.14-4.14c.2-.2.51-.2.71 0c.2.2.2.51 0 .71l-4.5 4.5c-.1.1-.23.15-.35.15Z"
                    />
                  </svg>
                </button>
              </div>
              <div className={`mobile-dropdown-list ${isCollegesDropdownOpen ? 'open' : ''}`}>
                {collegesList.map((college, index) => (
                  <Link 
                    key={index} 
                    to={`/college/${college.slug}`} 
                    className="mobile-dropdown-item"
                    onClick={closeMobileMenu}
                  >
                    <span className="item-arrow">&gt;</span> {college.name}
                  </Link>
                ))}
              </div>

              <div className="mobile-nav-row header-row">
                 <Link to="/contact" className="mobile-nav-link-text" onClick={closeMobileMenu}>Contact Us</Link>
              </div>

              <div className="mobile-nav-row header-row">
                 <Link to="/about" className="mobile-nav-link-text" onClick={closeMobileMenu}>About Us</Link>
              </div>
            </nav>

            <button type="button" onClick={handleApplyNowClick} className="mobile-apply-btn">
              APPLY NOW
            </button>
          </div>
        </div>
      </div>
    </>
  );
}